/**
 * Client-generated ids for new sections/fields. Conditions reference field ids, so the builder must
 * mint them before the template is saved; the server validates uniqueness + the earlier-only rule.
 *
 * NOT `crypto.randomUUID()` — that's Safari 15.4+, and the app floor is Safari 14. `getRandomValues`
 * is available, and these ids only need to be unique within one template.
 */
function rand(bytes: number): string {
  const a = new Uint8Array(bytes);
  crypto.getRandomValues(a);
  return Array.from(a, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function newId(prefix: string): string {
  return `${prefix}_${Date.now().toString(36)}${rand(6)}`;
}
